export const CLI_VERSION = '2.6.8'
